import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 text-foreground-800">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg" />
              </span>
              <span className="font-heading text-xl text-foreground-950">漫迹 MangaTrack</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专业的漫画追更工具，提供漫画更新提醒、最新话推送与连载进度查询，搭配更新日历与追更社区，让你追更不迷路。
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base text-foreground-950">站内导航</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li><Link className="hover:text-primary-600" to="/">首页</Link></li>
              <li><Link className="hover:text-primary-600" to="/category/rexue">漫画分类</Link></li>
              <li><Link className="hover:text-primary-600" to="/article/1">追更资讯</Link></li>
              <li><Link className="hover:text-primary-600" to="/about">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base text-foreground-950">热门分类</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              <li><Link className="hover:text-primary-600" to="/category/rexue">热血战斗</Link></li>
              <li><Link className="hover:text-primary-600" to="/category/lianai">恋爱治愈</Link></li>
              <li><Link className="hover:text-primary-600" to="/category/xuanyi">悬疑推理</Link></li>
              <li><Link className="hover:text-primary-600" to="/category/kehuan">科幻机甲</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-base text-foreground-950">联系方式</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2"><i className="ri-mail-line" /> hi@mangatrack.cn</li>
              <li className="flex items-center gap-2"><i className="ri-wechat-line" /> 公众号：漫迹追更</li>
              <li className="flex items-center gap-2"><i className="ri-bilibili-line" /> B站：漫迹MangaTrack</li>
              <li className="flex items-center gap-2"><i className="ri-map-pin-line" /> 中国 · 北京</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© 2026 漫迹 MangaTrack 保留所有权利。追更不迷路，快乐每一天。</p>
          <div className="flex gap-4">
            <span>使用条款</span>
            <span>隐私政策</span>
            <span>内容举报</span>
          </div>
        </div>
      </div>
    </footer>
  );
}